import agent, { prepareHeaders } from 'api/agent';
import { CreatedPrinterServer, PrinterServer, PrinterServerApiKey, TestPrintRequest } from 'api/models';

const PATH = '/PrinterServer';

export const PrinterServers = {
    getList: (restaurantId?: string): Promise<PrinterServer[]> =>
        agent.requests.get(PATH, { params: { restaurantId } }),
    getOne: (id: string): Promise<PrinterServer> => agent.requests.get(`${PATH}/${id}`),
    create: (restaurantId: string): Promise<CreatedPrinterServer> => {
        const model = {
            restaurantId,
        };

        return agent.requests.post(`${PATH}`, model);
    },
    update: (server: PrinterServer): Promise<CreatedPrinterServer> => {
        return agent.requests.put(`${PATH}/${server.id}`, server, prepareHeaders());
    },
    delete: (id: string): Promise<PrinterServer> => agent.requests.delete(`${PATH}/${id}`),
    testPrint: (serverId: string, model: TestPrintRequest): Promise<any> => {
        return agent.requests.post(`${PATH}/${serverId}/test-print`, model);
    },
    removePrinter: (serverId: string, printerIp: string) => {
        return agent.requests.delete(`${PATH}/${serverId}/printers/${printerIp}`);
    },
    retrieveApiKey: (serverId: string): Promise<PrinterServerApiKey> => {
        return agent.requests.get(`${PATH}/${serverId}/api-key`);
    },
    regenerateApiKey: (serverId: string): Promise<PrinterServerApiKey> => {
        return agent.requests.post(`${PATH}/${serverId}/api-key`);
    },
};
